import { render, staticRenderFns } from "./ShoppingTracking.vue?vue&type=template&id=d63a84ee&"
import script from "./ShoppingTracking.vue?vue&type=script&lang=js&"
export * from "./ShoppingTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports